import { Box, IconButton, Popover, TextField } from '@mui/material';
import { Clear } from '@mui/icons-material';
import React from 'react';

export type ICheckboxFilter = {
  [name: string]: {
    [key: string]: boolean;
  };
};

export type TextFilter = {
  [name: string]: string;
};

export interface TableTextFilterProps {
  anchorEl: HTMLButtonElement | null;
  anchorId: string;
  anchorLabel: string;
  textFilters: TextFilter;
  handleClose: () => void;
  updateText: (filterName: string, value: string) => void;
}

export const TableTextFilter = ({
  anchorEl,
  anchorLabel,
  anchorId,
  textFilters,
  handleClose,
  updateText,
}: TableTextFilterProps) => {
  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <Box
        sx={{
          p: 4,
          display: 'flex',
          alignItems: 'center',
          justifyItems: 'center',
        }}
      >
        <TextField
          label={anchorLabel}
          variant="outlined"
          fullWidth
          size="small"
          value={textFilters[anchorId]}
          onChange={e => {
            updateText(anchorId, e.target.value);
          }}
        />
        <IconButton
          color="primary"
          size="small"
          sx={{ ml: 2, mr: -1 }}
          onClick={() => {
            if (textFilters[anchorId]) {
              updateText(anchorId, '');
            } else {
              handleClose();
            }
          }}
        >
          <Clear fontSize="small" />
        </IconButton>
      </Box>
    </Popover>
  );
};
